import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from './ui/sheet';
import { ChevronDown, Menu } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
    setMobileMenuOpen(false);
  };

  const handleTeamClick = () => {
    navigate('/about');
    setMobileMenuOpen(false);
    setTimeout(() => {
      const teamSection = document.getElementById('team');
      if (teamSection) {
        teamSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-[#DDD5C7]">
      <nav className="container mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <div onClick={() => handleNavClick('/')} className="cursor-pointer flex items-center gap-2 sm:gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_biofab-labs/artifacts/ynofsip9_Punarvibes_Logo.png" 
            alt="Punarvibes Logo" 
            className="h-14 sm:h-20 w-auto"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          <button
            onClick={() => handleNavClick('/')}
            className={`${isActive('/') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} hover:text-[#D4A574] transition-colors`}
          >
            Home
          </button>
          
          <DropdownMenu>
            <DropdownMenuTrigger className={`${isActive('/about') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} hover:text-[#D4A574] transition-colors flex items-center gap-1`}>
              About Us
              <ChevronDown className="w-4 h-4" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border-[#DDD5C7]">
              <DropdownMenuItem onClick={() => handleNavClick('/about')} className="cursor-pointer">
                About Punarvibes
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleTeamClick} className="cursor-pointer">
                Our Team
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <button
            onClick={() => handleNavClick('/products')}
            className={`${isActive('/products') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} hover:text-[#D4A574] transition-colors`}
          >
            Our Products
          </button>
          
          <button
            onClick={() => handleNavClick('/careers')}
            className={`${isActive('/careers') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} hover:text-[#D4A574] transition-colors`}
          >
            Careers
          </button>

          <Button onClick={() => handleNavClick('/contact')} className="bg-[#D4A574] hover:bg-[#C09460] text-white">
            Contact
          </Button>
        </div>

        {/* Mobile Menu */}
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" className="text-[#4A5D4E]">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-white w-[300px] sm:w-[400px]">
            <div className="flex flex-col gap-6 mt-8">
              <button
                onClick={() => handleNavClick('/')}
                className={`${isActive('/') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} text-left text-lg hover:text-[#D4A574] transition-colors`}
              >
                Home
              </button>
              
              <div>
                <div className="text-[#4A5D4E] font-semibold text-lg mb-2">About Us</div>
                <div className="flex flex-col gap-3 ml-4">
                  <button
                    onClick={() => handleNavClick('/about')}
                    className="text-[#5A6B5E] text-left hover:text-[#D4A574] transition-colors"
                  >
                    About Punarvibes
                  </button>
                  <button
                    onClick={handleTeamClick}
                    className="text-[#5A6B5E] text-left hover:text-[#D4A574] transition-colors"
                  >
                    Our Team
                  </button>
                </div>
              </div>

              <button
                onClick={() => handleNavClick('/products')}
                className={`${isActive('/products') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} text-left text-lg hover:text-[#D4A574] transition-colors`}
              >
                Our Products
              </button>
              
              <button
                onClick={() => handleNavClick('/careers')}
                className={`${isActive('/careers') ? 'text-[#D4A574] font-semibold' : 'text-[#4A5D4E]'} text-left text-lg hover:text-[#D4A574] transition-colors`}
              >
                Careers
              </button>

              <Button 
                onClick={() => handleNavClick('/contact')} 
                className="bg-[#D4A574] hover:bg-[#C09460] text-white w-full"
              >
                Contact
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
};

export default Header;
